// src/redux/store.js
import { createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";

import genderReducer from "./reducers/genderReducer";
import industryReducer from './reducers/industryReducer';
import companyCategoryReducer from './reducers/companyCategoryReducer';
import cityReducer from "./reducers/cityReducer";
import jobCategoriesReducer from "./reducers/jobCategoriesReducer";
import jobTypeReducer from "./reducers/jobtypeReducer";
import salaryTypeReducer from "./reducers/salaryTypeReducer";
import designationReducer from "./reducers/designationReducer";
import skillReducer from "./reducers/skillReducer";
import countryReducer from "./reducers/countryReducer";
import userTypeRecruiter from "./reducers/userTypeRecruiter"
// import workLevelTypeReducer from "./reducers/workLevelTypeReducer"
import workLevelReducer from "./reducers/workLevelTypeReducer"
import workLocationTypeReducer from "./reducers/workLocationTypeReducer"
import companySizeReducer from "./reducers/companySizeReducer";
import getInstitutesReducer from "./reducers/getInstitutesReducer";
import getCompaniesReducer from "./reducers/getCompaniesReducer";
import getAllOrgsReducer from "./reducers/getAllOrgsReducer";
import getOrgTypesReducer from "./reducers/getOrgTypesReducer";
import specializationReducer from "./reducers/specializationReducer";
import qualificationReducer from "./reducers/qualificationReducer"
import { Language } from "@mui/icons-material";
import LanguageReducer from "./reducers/LanguageReducer";



const rootReducer = combineReducers({
  gender: genderReducer,
  industry: industryReducer,
  companyCategory: companyCategoryReducer,
  cities: cityReducer,
  jobCategories: jobCategoriesReducer,
  jobType: jobTypeReducer,
  salaryType: salaryTypeReducer,
  designation: designationReducer,
  skill: skillReducer,
  country: countryReducer,
  companySize: companySizeReducer,
  userType: userTypeRecruiter,
  workLevelType: workLevelReducer,
  workLocationType: workLocationTypeReducer,
  institute: getInstitutesReducer,
  getcompanies: getCompaniesReducer,
  getallorgs: getAllOrgsReducer,
  getorgstypes: getOrgTypesReducer,
  specialization: specializationReducer,
  qualification: qualificationReducer,
  language : LanguageReducer,

});

const store = createStore(
  rootReducer,
  //   composeWithDevTools(applyMiddleware(thunk))
  applyMiddleware(thunk) // Without DevTools

);

export default store;
